import axios from 'axios';
import headers from "./Header";
//const var
const
    // headersAppJson = { "Content-Type": "application/json" },
    // iamUrl = "/iam",
    odwURL = "https://odw-api-dev.bps.go.id",
    tabelDinamisBackendURL = "/api/tabel-dinamis/v3";
class TabelDinamisServicesV3 {
    getAllSubject() {
        let url = this.constructUrl('/subject');
        return axios.get(url);
    }

    getCategoryByProject(val) {
        let url = this.constructUrl('/project/category/'+val);
        return axios.get(url);
    }

    getDatasetBySubjectName(val) {
        let url = this.constructUrl('/dataset?subject=' + val);
        return axios.get(url);
    }

    getDatasetByCategoryAndProject(category,project) {
        let url = this.constructUrl('/dataset/category?category='+category+'&project='+project, {headers: headers()});
        return axios.get(url);
    }

    getIndicatorByDatasetName(val) {
        let url = this.constructUrl('/indicator?dataset=' + val);
        return axios.get(url);
    }

    getPeriodByDatasetName(val) {
        let url = this.constructUrl('/period?dataset=' + val);
        return axios.get(url);
    }

    getDimensionByDatasetId(val) {
        let url = this.constructUrl('/dimension/dataset/' + val);
        return axios.get(url);
    }

    getChildrenRegionByDatasetIdDimensionIdParentRegionId(dataset, dimension, parentRegion) {
        let url = this.constructUrl('/region-children?dataset=' + dataset + '&dimension=' + dimension + '&parentRegion=' + parentRegion);
        return axios.get(url);
    }

    constructUrl(endpoint) {
        return tabelDinamisBackendURL + endpoint;
    }

    getODWAgregat(data) {
        let url = odwURL + "/odw/api/agregat-data";

        return axios.post(url, data);
    }

    getExcelStyle() {
        return axios.get(window.location.origin + "/css/table-dinamis-print-v3-variable-less.css");
    }
}

export default new TabelDinamisServicesV3();